import { Link, useNavigate } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../../components/panel/panel.jsx";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import * as formik from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import axiosClient from "../../../../../config/axios.js";

function NewVehicleType() {
  const navigate = useNavigate();
  const { Formik } = formik;

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">Configuración</li>
            <li className="breadcrumb-item">
              <Link to="/catalogs/brandsModels?tab=typesVehicles">
                Tipos de Vehículos
              </Link>
            </li>
            <li className="breadcrumb-item active">Nuevo Tipo</li>
          </ol>
          <h1 className="page-header mb-0">
            Registro de nuevo Tipo de Vehículo
          </h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Registro de nuevo Tipo de Vehículo</PanelHeader>
            <PanelBody>
              <Formik
                validationSchema={yup.object().shape({
                  vehicle_type_name: yup
                    .string()
                    .required("Ingrese el nombre del tipo de vehículo"),
                })}
                onSubmit={(values, { setSubmitting }) => {
                  setSubmitting(false);

                  Swal.fire({
                    title: "¿Registrar tipo de vehículo?",
                    text: "¿Deseas guardar este nuevo tipo de vehículo?",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Sí, guardar",
                    cancelButtonText: "Cancelar",
                    reverseButtons: true,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      axiosClient
                        .post("/vehicleTypes/save", values)
                        .then((response) => {
                          Swal.fire({
                            title: "Registro exitoso",
                            text: "Se ha registrado el nuevo tipo de vehículo.",
                            icon: "success",
                            confirmButtonText: "Cerrar",
                          }).then(() => {
                            navigate(
                              "/catalogs/brandsModels?tab=typesVehicles"
                            );
                          });
                        })
                        .catch((err) => {
                          let message = "";
                          if (err.response?.data?.original?.code === "23505") {
                            message =
                              "El tipo de vehículo ya existe. Ingresa uno diferente.";
                          } else {
                            message =
                              err.response?.data?.message ||
                              "Error al registrar el tipo de vehículo.";
                          }
                          Swal.fire({
                            title: "Ups!",
                            text: message,
                            icon: "error",
                            confirmButtonText: "Cerrar",
                          });
                        });
                    }
                  });
                }}
                initialValues={{
                  vehicle_type_name: "",
                  is_visible: true,
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  values,
                  touched,
                  errors,
                  setFieldValue,
                }) => (
                  <Form noValidate onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Form.Group as={Col} md="12">
                        <Form.Label>Nombre del Tipo de Vehículo</Form.Label>
                        <Form.Control
                          type="text"
                          name="vehicle_type_name"
                          placeholder="Ejemplo: Camión, Sedan, SUV..."
                          value={values.vehicle_type_name}
                          onChange={handleChange}
                          isInvalid={!!errors.vehicle_type_name}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.vehicle_type_name}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>

                    {/* Switch para mostrar/ocultar */}
                    <Row className="mb-3">
                      <Form.Group as={Col} md="12">
                        <Form.Check
                          type="switch"
                          id="is_visible"
                          label="Mostrar en la lista de tipos de vehículos"
                          checked={values.is_visible}
                          onChange={(e) =>
                            setFieldValue("is_visible", e.target.checked)
                          }
                        />
                      </Form.Group>
                    </Row>

                    <Row className="mb-3">
                      <Col md="12">
                        <Button type="submit">Guardar Tipo</Button>{" "}
                        <Link
                          to={"/catalogs/brandsModels?tab=typesVehicles"}
                          className="btn btn-info"
                        >
                          Regresar
                        </Link>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
}

export default NewVehicleType;
